var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc115(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.6707mm",
    height: "12.1574mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 716.98 746.88",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465236576656"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M522.57 380.02c0,-90.66 -73.5,-164.16 -164.16,-164.16 -90.67,0 -164.17,73.5 -164.17,164.16 0,90.67 73.5,164.17 164.17,164.17 90.66,0 164.16,-73.5 164.16,-164.17zm-230 23.25l0 -36.57 131.65 0 0 36.57 -131.65 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M535.25 746.88l-353.68 0 -181.57 -199.28 161.09 0 67.61 86.96 265.76 0 0 13.66 -272.42 0 -67.61 -86.96 -123.38 0 156.53 171.81 347.52 0 0.15 13.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.382842 -0.923805 0.923805 0.382842 178.254 737.406)",
    width: 106.63,
    height: 13.65
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.923872 -0.38268 0.38268 0.923872 482.924 643.963)",
    width: 13.65,
    height: 106.63
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M536.22 745.9l-10.08 -9.26 159.79 -175.38 -120.61 0 -68.59 84.51 -10.56 -8.61 72.65 -89.56 158.16 0 -180.75 198.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M705.76 235.85l-133.11 0 -2.11 -2.76c-48.69,-69.57 -128.05,-111.46 -212.94,-112.47 -85.34,0.56 -165.18,42.54 -214.07,112.47l-2.11 2.76 -133.11 -0.01 4.39 -9.76c61.27,-135.91 195.88,-224.17 344.94,-226.08 148.61,2.37 282.55,90.52 343.57,226.09l4.56 9.74 -0.01 0.02zm-126.13 -13.65l104.51 0c-60.7,-125.56 -187.08,-206.3 -326.54,-208.55 -139.88,1.92 -266.84,82.67 -327.86,208.55l104.68 0.01c51.64,-71.93 134.63,-114.84 223.18,-115.24 88.07,0.97 170.54,43.79 222.04,115.27l-0.01 -0.01 0 -0.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.382842 -0.923805 0.923805 0.382842 449.6 132.581)",
    width: 106.63,
    height: 13.65
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.923872 -0.38268 0.38268 0.923872 203.707 46.142)",
    width: 13.65,
    height: 106.63
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc115);
export default __webpack_public_path__ + "static/media/ic_1_15.ed82ffdb1cf149b56e7dbeb4033edced.svg";
export { ForwardRef as ReactComponent };